import React from 'react';

const LoadingScreen = ({ message = 'Preparing your experience...' }) => {
    return (
        <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-white">
            {/* Background decoration */}
            <div className="absolute inset-0 overflow-hidden pointer-events-none">
                <div className="absolute -top-24 -left-24 w-64 h-64 bg-emerald-50 rounded-full blur-3xl opacity-60"></div>
                <div className="absolute -bottom-24 -right-24 w-64 h-64 bg-yellow-50 rounded-full blur-3xl opacity-60"></div>
            </div>

            <div className="relative z-10 flex flex-col items-center">
                {/* Logo Container */}
                <div className="mb-8 relative">
                    <div className="relative w-32 h-32 flex items-center justify-center">
                        {/* Pulsing rings */}
                        <div className="absolute inset-0 rounded-full bg-emerald-100 animate-ping opacity-20"></div>
                        <div className="absolute inset-2 rounded-full bg-emerald-50 animate-pulse opacity-40"></div>

                        {/* Logo Image */}
                        <img
                            src="/logo.png"
                            alt="Brooks Flower"
                            className="w-24 h-auto object-contain relative z-10"
                        />
                    </div>
                </div>

                {/* Loading Text */}
                <h2 className="text-xl font-medium text-gray-800 tracking-wide mb-2 font-serif">
                    Brooks Flower
                </h2>
                <p className="text-sm text-gray-500 animate-pulse">
                    {message}
                </p>

                {/* Progress Bar */}
                <div className="mt-8 w-48 h-1 bg-gray-100 rounded-full overflow-hidden">
                    <div className="h-full bg-gradient-to-r from-emerald-500 to-green-600 animate-progress"></div>
                </div>
            </div>

            <style>{`
        @keyframes progress {
          0% { transform: translateX(-100%); }
          50% { transform: translateX(0%); }
          100% { transform: translateX(100%); }
        }
        .animate-progress {
          animation: progress 1.5s infinite ease-in-out;
          width: 50%;
        }
      `}</style>
        </div>
    );
};

export default LoadingScreen;
